import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Tools|Merges|Unmerge History|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.MergeCandidates,
	portal: 'SP',
};

type LocNameStart = 'SPToolsMergesUnmergeHistory';
export type SPToolsMergesUnmergeHistoryLocNames =
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}ContentNoCandidate`
	| `${LocNameStart}LabelCreated`
	| `${LocNameStart}LabelStatus`
	| `${LocNameStart}LabelWinner`;

export const spToolsMergesUnmergeHistoryLocs: LocDefs<SPToolsMergesUnmergeHistoryLocNames> = {
	SPToolsMergesUnmergeHistoryTitlePage: {
		defaultValue: 'Unmerge History',
		description: 'Page Title',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName: 'MergeCandidates/Tools.Merges.UnmergeHistory.Title.UnmergeHistory',
		...sharedProperties,
	},
	SPToolsMergesUnmergeHistoryTitleTab: {
		defaultValue: 'Unmerge History',
		description: 'Tab Title',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		legacyName: 'MergeCandidates/Tools.Merges.UnmergeHistory.Title.Tab',
		...sharedProperties,
	},
	SPToolsMergesUnmergeHistoryContentNoCandidate: {
		defaultValue: 'Candidate no longer exists',
		description: 'No candidate text',
		displayPath: `${pathStart}No Candidate`,
		displayType: 'Content',
		legacyName: 'MergeCandidates/Tools.Merges.Content.NoCandidate',
		...sharedProperties,
	},
	SPToolsMergesUnmergeHistoryLabelCreated: {
		defaultValue: 'Created',
		description: 'Column heading for: Created.',
		displayPath: `${pathStart}Created`,
		displayType: 'Label',
		legacyName: 'MergeCandidates/Tools.Merges.UnmergeHistory.ColumnHeading.Created',
		...sharedProperties,
	},
	SPToolsMergesUnmergeHistoryLabelStatus: {
		defaultValue: 'Status',
		description: 'Column heading for: Status.',
		displayPath: `${pathStart}Status`,
		displayType: 'Label',
		legacyName: 'MergeCandidates/Tools.Merges.UnmergeHistory.ColumnHeading.Status',
		...sharedProperties,
	},
	SPToolsMergesUnmergeHistoryLabelWinner: {
		defaultValue: 'Winner',
		description: 'Column heading for: Winner.',
		displayPath: `${pathStart}Winner`,
		displayType: 'Label',
		legacyName: 'MergeCandidates/Tools.Merges.UnmergeHistory.ColumnHeading.Winner',
		...sharedProperties,
	},
};

export type SPToolsMergesUnmergeHistoryLocType = LocMap<SPToolsMergesUnmergeHistoryLocNames>;
